import React from 'react';

import { Flex, Tag, Typography } from 'antd';

import { formatISODate } from '@/helpers/dates';

export const StatusDeletedHeader = ({ timeLineEvent }) => {
  const cancelledBy =
    timeLineEvent.disabled_by?.email ||
    timeLineEvent.disabled_by?.name ||
    'Unknown user';
  const cancelledAt = timeLineEvent.disabled_at || timeLineEvent.created_at;
  const statusType = timeLineEvent.sub_status ? 'Substatus' : 'Status';

  return (
    <Flex justify="space-between" style={{ width: '100%' }}>
      <Typography.Text
        style={{
          color: '#808080',
          marginLeft: '8px',
        }}
      >
        <b>{statusType} cancelled</b> &nbsp;by&nbsp;
        <b>{cancelledBy}</b>
      </Typography.Text>
      <Tag bordered={false} style={{ color: '#808080' }}>
        {formatISODate(cancelledAt, 'dd/MM/yyyy - HH:mm:ss')}
      </Tag>
    </Flex>
  );
};
